import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Master Kelompok Product',
    title_form: 'Form Kelompok Product',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Master Kelompok Product',
        href: '/adm/logistic/master/kelompok-product',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_kelompok_product',
    sortDesc: false,
    fields: [
      {
        key: 'code_kelompok_prod',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
        sortable: true,
      },
      {
        key: 'gudang',
        label: 'Gudang',
      },
      {
        key: 'department',
        label: 'Department',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      kelompok: '',
      id_gudang: '',
      id_department: '',
      acc_hpp: '',
      acc_jual: '',
      acc_retur: '',
      acc_persediaan: '',
      acc_pengiriman_beli: '',
      acc_pengiriman_jual: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeKelProduct(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        kelompok: '',
        id_gudang: '',
        id_department: '',
        acc_hpp: '',
        acc_jual: '',
        acc_retur: '',
        acc_persediaan: '',
        acc_pengiriman_beli: '',
        acc_pengiriman_jual: '',
      },
    });
  },
};

export const actions = {
  async searchKelProduct(context, params = null) {
    let result = await ApiGetRequest(`logistic/kelompok-product`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllKelProduct({ commit }, params = null) {
    commit('changeKelProduct', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/kelompok-product`, params);
    commit('changeKelProduct', {
      items: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListKelProduct({ commit, state }) {
    commit('changeKelProduct', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/kelompok-product`, params);
    commit('changeKelProduct', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailKelProduct({ commit, state }, payload = null) {
    commit('changeKelProduct', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/kelompok-product/${payload.id}`);
    commit('changeKelProduct', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createKelProduct({ commit, state, dispatch }) {
    commit('changeKelProduct', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `logistic/kelompok-product`,
      state.data.form
    );
    commit('changeKelProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateKelProduct({ commit, state, dispatch }, payload = null) {
    commit('changeKelProduct', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/kelompok-product/${payload.id}`,
      state.data.form
    );

    commit('changeKelProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteKelProduct({ commit, dispatch }, payload = null) {
    commit('changeKelProduct', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `logistic/kelompok-product/${payload.id}`
    );
    commit('changeKelProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
